import { observer } from 'mobx-react';
import React from 'react';

function EmailLinksAlert({ isShowingLinkAlert, t }) {
    return (
        <div
            className="email-attention"
            style={{
                opacity: isShowingLinkAlert ? '1' : '0',
            }}
        >
            {t('Links don’t work. This is only a simulation')}.
        </div>
    );
}

export default observer(EmailLinksAlert);
